import React from 'react'

export const Down = () => (
    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <defs>
            <path id="asdf" d="M17.293 8.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L12 13.586l5.293-5.293z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="aaaa" fill="#fff">
                <use href="#asdf" />
            </mask>
            <g fill="#fff" mask="url(#aaaa)">
                <path d="M0 0h24v24H0z" />
            </g>
        </g>
    </svg>
)